// extracted by mini-css-extract-plugin
export var content = "InvestorsSection-module--content--05018";
export var gridImage = "InvestorsSection-module--gridImage--ac89d";
export var root = "InvestorsSection-module--root--a3c5a";